export const CREATE_ORDER_REQUEST = "CREATE_ORDER_REQUEST";
export const CREATE_ORDER_SUCCESS = "CREATE_ORDER_SUCCESS";
export const CREATE_ORDER_FAIL = "CREATE_ORDER_FAIL";

export const PAYMENT_VERIFICATION_REQUEST = "PAYMENT_VERIFICATION_REQUEST";
export const PAYMENT_VERIFICATION_SUCCESS = "PAYMENT_VERIFICATION_SUCCESS";
export const PAYMENT_VERIFICATION_FAIL = "PAYMENT_VERIFICATION_FAIL";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";


export const MY_ORDERS_REQUEST = "MY_ORDERS_REQUEST";
export const MY_ORDERS_SUCCESS = "MY_ORDERS_SUCCESS";
export const MY_ORDERS_FAIL = "MY_ORDERS_FAIL";

export const ADMIN_ORDERS_REQUEST = "ADMIN_ORDERS_REQUEST";
export const ADMIN_ORDERS_SUCCESS = "ADMIN_ORDERS_SUCCESS";
export const ADMIN_ORDERS_FAIL = "ADMIN_ORDERS_FAIL";

export const MY_UNPAID_ORDERS_REQUEST = "MY_UNPAID_ORDERS_REQUEST";
export const MY_UNPAID_ORDERS_SUCCESS = "MY_UNPAID_ORDERS_SUCCESS";
export const MY_UNPAID_ORDERS_FAIL = "MY_UNPAID_ORDERS_FAIL";

export const PROCESS_ORDERS_REQUEST = "PROCESS_ORDERS_REQUEST";
export const PROCESS_ORDERS_SUCCESS = "PROCESS_ORDERS_SUCCESS";
export const PROCESS_ORDERS_FAIL = "PROCESS_ORDERS_FAIL";

export const ALL_UNPAID_ORDERS_REQUEST = "ALL_UNPAID_ORDERS_REQUEST";
export const ALL_UNPAID_ORDERS_SUCCESS = "ALL_UNPAID_ORDERS_SUCCESS";
export const ALL_UNPAID_ORDERS_FAIL = "ALL_UNPAID_ORDERS_FAIL";

export const UPDATE_ORDER_REQUEST = "UPDATE_ORDER_REQUEST";
export const UPDATE_ORDER_SUCCESS = "UPDATE_ORDER_SUCCESS";
export const UPDATE_ORDER_RESET = "UPDATE_ORDER_RESET";
export const UPDATE_ORDER_FAIL = "UPDATE_ORDER_FAIL";

export const UPDATE_UNPAID_ORDER_REQUEST = "UPDATE_UNPAID_ORDER_REQUEST";
export const UPDATE_UNPAID_ORDER_SUCCESS = "UPDATE_UNPAID_ORDER_SUCCESS";
export const UPDATE_UNPAID_ORDER_RESET = "UPDATE_UNPAID_ORDER_RESET";
export const UPDATE_UNPAID_ORDER_FAIL = "UPDATE_UNPAID_ORDER_FAIL";

export const DELETE_ORDER_REQUEST = "DELETE_ORDER_REQUEST";
export const DELETE_ORDER_SUCCESS = "DELETE_ORDER_SUCCESS";
export const DELETE_ORDER_RESET = "DELETE_ORDER_RESET";
export const DELETE_ORDER_FAIL = "DELETE_ORDER_FAIL";

export const DELETE_UNPAID_ORDER_REQUEST = "DELETE_UNPAID_ORDER_REQUEST";
export const DELETE_UNPAID_ORDER_SUCCESS = "DELETE_UNPAID_ORDER_SUCCESS";
export const DELETE_UNPAID_ORDER_RESET = "DELETE_UNPAID_ORDER_RESET";
export const DELETE_UNPAID_ORDER_FAIL = "DELETE_UNPAID_ORDER_FAIL";

export const ORDER_DETAILS_REQUEST = "ORDER_DETAILS_REQUEST";
export const ORDER_DETAILS_SUCCESS = "ORDER_DETAILS_SUCCESS";
export const ORDER_DETAILS_FAIL = "ORDER_DETAILS_FAIL";

export const UNPAID_ORDER_DETAILS_REQUEST = "UNPAID_ORDER_DETAILS_REQUEST";
export const UNPAID_ORDER_DETAILS_SUCCESS = "UNPAID_ORDER_DETAILS_SUCCESS";
export const UNPAID_ORDER_DETAILS_FAIL = "UNPAID_ORDER_DETAILS_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";



